import React, { useContext, useState, useEffect } from 'react'
import './Comments.css'
import moment from 'moment'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../product/common/components'
import AuthContext from '../../product/context/auth/authContext'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import Loaders from '../../custom/components/molecules/Loaders'
import AlertContext from '@/product/context/alert/alertContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import CustomDialog from '@/product/components/organisms/Dialog'
import NotesContext from '../../product/context/notes/notesContext'
import { IconButton, Button } from '@mui/material'
import NotesCustomTable from '@/custom/components/organisms/NotesCustomTable'
const NotesPopup = (props) => {
    const [previewImage, setPreviewImage] = useState(null)
    const authContext = useContext(AuthContext)
    const notesContext = useContext(NotesContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const {
        all_notes,
        responseStatus,
        getAllNotes,
        notesManage,
        clearResponse,
    } = notesContext

    const [isLoading, setIsLoading] = useState(false)
    const { data } = props
    const toggleFullScreenPopup = props.function
    const { user } = authContext
    const formikNote = useFormik({
        initialValues: {
            notes: '',
            id: 0,
            project_id: 0,
            user_id: 0,
            action: 'addComment',
            orderby: 'un.id, desc',
            uploadimages: '',
            filters: {
                project_id: {
                    value: data?.id,
                    type: 'in',
                    field: 'un.project_id',
                },
            },
        },
        validationSchema: Yup.object({
            notes: Yup.string().required('Required!'),
        }),
        onSubmit: (values) => {
            values.action = 'addComment'
            values.project_id = data?.id
            values.filters.project_id.value = data?.id
            if (user?.admin_id) {
                values.user_id = user?.admin_id ? user?.admin_id : 0
                values.username = user?.username
                    ? user?.username
                    : user?.emp_firstname + '' + user?.emp_lastname

                notesManage(values, 'addNotespopup')
            }
        },
    })

    const resetForm = () => {
        formikNote.values.id = 0
        formikNote.values.action = 'addComment'
        formikNote.values.project_id = 0
        formikNote.values.uploadimages = ''
        formikNote.values.user_id = 0
        formikNote.values.notes = ''
    }

    const [addNotesStatus, setAddNotesStatus] = useState(false)

    const handleAddNotesStatus = () => {
        setAddNotesStatus(!addNotesStatus)
        formikNote.setFieldValue('notes', '')
    }

    useEffect(() => {
        if (data.status === 'viewListing') {
            let initialfilter = {
                project_id: data.id,
                from: 'productComment',
                action: 'getSellerNotes',
                user_id: data.sellerId,
            }
            setIsLoading(true)

            getAllNotes(initialfilter)
        }
    }, [data])

    useEffect(() => {
        if (responseStatus && responseStatus?.from === 'addNotespopup') {
            formikNote.values.action = ''
            formikNote.values.notes = ''
            formikNote.values.uploadimages = ''
            setAlert('Notes Added Successfully', 'success')
            setIsLoading(true)
            let initialfilter = {
                project_id: data.id,
                from: 'productComment',
                action: 'getSellerNotes',
                user_id: data.sellerId,
            }
            getAllNotes(initialfilter)
            clearResponse()
            handleAddNotesStatus()
        }
    }, [responseStatus])
    const addNotesField = {
        formik: formikNote,
        data: [
            {
                label: 'Notes *',
                placeholder: 'Enter notes',
                type: 'textarea',
                class: `col-12`,
                name: 'notes',
                rows: 4,
            },
            {
                type: 'uploadDropZone',
                name: 'uploadimages',
                titleText: 'Upload product images',
                innerText: 'Recommended dimensions: 500px * 500px',
                class: 'col-12',
                folder: 'product',
                multiple: false,
                accept: 'image/*',
            },
        ],
    }
    const [tableBody, setTableBody] = useState([])

    useEffect(() => {
        if (all_notes && all_notes.all_records) {
            setTableBody(all_notes.all_records)
            setIsLoading(false)
        }
    }, [all_notes])
    const columns = [
        {
            header: 'Username',
            accessor: 'username',
            minWidth: '150px',
        },
        {
            header: 'Notes',
            accessor: 'notes',
            width: '460px',
            minWidth: '300px',
        },
        {
            header: 'Image',
            accessor: 'uploadimages',
            minWidth: '120px',
            render: (data) =>
                data?.uploadimages ? (
                    <img
                        src={global.images_url + data.uploadimages}
                        alt={data.username}
                        style={{
                            height: '110px',
                            width: '120px',
                            objectFit: 'cover',
                            borderRadius: '6px',
                        }}
                    />
                ) : (
                    '-'
                ),
        },
        {
            header: 'Date',
            accessor: 'date',
            minWidth: '200px',
            render: (data) => dateTimeFormatFunction(data?.date),
        },
    ]
    return (
        <>
            <FullScreenPopup
                modaltitle={'Notes'}
                open={data.status === 'viewListing' ? data.popup : false}
                handleClose={() => {
                    clearResponse()
                    resetForm()
                    toggleFullScreenPopup(false)
                }}
            >
                <div className="addUserModal customContainer">
                    <div className="dashboard listing mt-0">
                        {/* {isLoading && <Loaders name="table" isLoading={isLoading} />} */}
                        {isLoading ? (
                            <Loaders name="comment" isLoading={isLoading} />
                        ) : (
                            <div className="cmtPgWrpr">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    {/* <h4 className="m-0">Notes</h4> */}
                                    <PrimaryButton
                                        id="open_add_note"
                                        label={'Add Notes'}
                                        onClick={() => setAddNotesStatus(true)}
                                    />
                                </div>
                                <NotesCustomTable
                                    columns={columns}
                                    data={tableBody}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </FullScreenPopup>

            <CustomDialog
                title={'Add Notes'}
                open={addNotesStatus}
                function={handleAddNotesStatus}
            >
                <div className="row">{mapData(addNotesField)}</div>

                <div className="actionWrapper">
                    <Button
                        id="auction_cancel"
                        onClick={() => handleAddNotesStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikNote.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="auction_table_submit"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>

            {/* Full Image Preview Popup */}
            <CustomDialog
                title={'Image Preview'}
                open={!!previewImage}
                function={() => setPreviewImage(null)}
            >
                <div style={{ textAlign: 'center' }}>
                    <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '75vh',
                            objectFit: 'contain',
                            borderRadius: '8px',
                        }}
                    />
                </div>
            </CustomDialog>
        </>
    )
}
export default NotesPopup
